import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "h2 text-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-3 g-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "body-image w-100px h-100px" }
const _hoisted_7 = { class: "body-content d-flex flex-column justify-content-center align-items-center px-8" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = { class: "text-body-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, "Instituciones participantes (" + _toDisplayString(_ctx.listClubs.length) + ")", 1),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listClubs, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col"
          }, [
            _createVNode(_component_router_link, {
              to: `teams/${item.abrev}`,
              class: "card mb-4 shadow text-black border border-2 border-primary border-hover text-center",
              style: {"max-width":"540px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "w-50px border border-4 border-secondary rounded-circle p-1 bg-white m-0",
                  src: `https://sismaster.perufedup.com/writable/uploads/${item.flags}`,
                  style: {"margin":"0px auto","position":"absolute","margin-top":"-30px !important","left":"43%"}
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_avatar, {
                      class: "img-fluid rounded-start w-100 h-100 bg-white",
                      shape: "square",
                      src: `https://sismaster.perufedup.com/writable/uploads/${item.avatar}`
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(item.business) + " (" + _toDisplayString(item.abrev) + ")", 1),
                    _createElementVNode("p", _hoisted_9, [
                      _createElementVNode("small", _hoisted_10, "Registró (" + _toDisplayString(item.quantity) + ") participantes", 1)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}